<header class="topbar">
  <a routerLink="/" class="brand" aria-label="SMS Murilo — Página inicial">
    <span class="brand-title">SMS Murilo</span>
    <span class="brand-subtitle">Softwares Inteligentes</span>
  </a>

  <nav class="menu" aria-label="Navegação principal">
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
    <a routerLink="/resources" routerLinkActive="active">Recursos</a>
    <a routerLink="/products" routerLinkActive="active">Produtos</a>
    <a routerLink="/technologies" routerLinkActive="active">Tecnologias</a>
    <a routerLink="/about" routerLinkActive="active">Sobre</a>
    <a routerLink="/login" routerLinkActive="active" class="login-button">Login</a>
  </nav>
</header>
